<template>
  <div>
    <div class="d-flex align-center mb-6 px-1">
      <div class="caption font-weight-black text-uppercase tracking-widest grey--text">Maestro de Condiciones de Pago</div>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        class="font-weight-black text-uppercase tracking-widest rounded-lg px-8 h-44 shadow-lg shadow-success"
        @click="update(-1)"
      >
        <v-icon left size="16">fas fa-plus-circle</v-icon>
        Nueva Condición
      </v-btn>
    </div>

    <v-card outlined class="bg-lightgrey border-dashed pa-4 mb-6 d-flex align-center rounded-xl elevation-0">
      <v-text-field
        v-model="search"
        placeholder="Buscar condición por nombre..."
        prepend-inner-icon="fas fa-search"
        outlined
        dense
        hide-details
        class="modern-search-input bg-white elevation-0"
        :loading="loading"
        color="primary"
      ></v-text-field>
    </v-card>

    <v-card outlined class="modern-table-card elevation-0 overflow-hidden">
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="10"
        :loading="loading"
        :search="search"
        dense
        class="modern-data-table"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'fas fa-angle-double-left',
          lastIcon: 'fas fa-angle-double-right',
          prevIcon: 'fas fa-angle-left',
          nextIcon: 'fas fa-angle-right'
        }"
      >
        <template v-slot:item.name="{ item }">
          <div class="d-flex align-center py-2">
            <v-avatar size="32" color="blue lighten-5" class="mr-3">
              <v-icon x-small color="blue darken-2">fas fa-credit-card</v-icon>
            </v-avatar>
            <span class="body-2 font-weight-black primary--text">{{ item.name }}</span>
          </div>
        </template>

        <template v-slot:item.days="{ item }">
          <span class="body-2">{{ item.days === null ? '—' : (item.days === 0 ? 'Contado' : `${item.days} días`) }}</span>
        </template>

        <template v-slot:item.active="{ item }">
          <v-chip x-small label :color="item.active ? 'success' : 'grey'" dark class="font-weight-bold">
            {{ item.active ? 'Activa' : 'Inactiva' }}
          </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn icon color="primary" class="grey lighten-4" small @click.stop="update(item.id)">
            <v-icon size="14">fas fa-pen</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="showDialog" max-width="520" content-class="modern-dialog-shadow" persistent>
      <v-card class="overflow-hidden rounded-xl bg-white elevation-24">
        <payment-condition-create-update
          :id="selectedId"
          @updated="fetch"
          @close="showDialog=false"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { fetchPaymentConditions } from '@/api/salesNotes'
import notifications from '@/utils/notifications'
import PaymentConditionCreateUpdate from '@/components/sales/PaymentConditionCreateUpdate.vue'

export default {
  name: 'PaymentConditions',
  components: { PaymentConditionCreateUpdate },
  data() {
    return {
      loading: false,
      selectedId: -1,
      items: [],
      search: '',
      showDialog: false,
      headers: [
        { text: 'Orden', align: 'start', value: 'sort', class: 'caption font-weight-black tracking-widest grey--text', width: '90px' },
        { text: 'Condición', align: 'start', value: 'name', class: 'caption font-weight-black tracking-widest grey--text' },
        { text: 'Días', align: 'start', value: 'days', class: 'caption font-weight-black tracking-widest grey--text', width: '120px' },
        { text: 'Estado', align: 'center', value: 'active', class: 'caption font-weight-black tracking-widest grey--text', width: '110px' },
        { text: 'Acciones', value: 'actions', align: 'center', sortable: false, class: 'caption font-weight-black tracking-widest grey--text', width: '100px' }
      ],
    }
  },
  methods: {
    async fetch() {
      this.loading = true
      try {
        this.items = await fetchPaymentConditions()
      } catch (err) {
        notifications.showError('Error cargando condiciones de pago: ' + err)
      } finally {
        this.loading = false
      }
    },
    update(id) {
      this.selectedId = id
      this.showDialog = true
    }
  },
  mounted() {
    this.fetch()
  }
}
</script>

<style scoped>
.tracking-widest { letter-spacing: 1.5px; }
.bg-lightgrey { background-color: #f8fbfc !important; }
.border-dashed { border: 1px dashed #e2e8f0 !important; }
.h-44 { height: 44px !important; }
.shadow-lg { box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important; }
.shadow-success { box-shadow: 0 10px 15px -3px rgba(34, 197, 94, 0.3) !important; }

.modern-search-input { border-radius: 24px !important; width: 100%; max-width: 400px; }
.modern-search-input >>> fieldset { border-radius: 24px !important; border: 1px solid #e2e8f0 !important; }

.modern-table-card { border-radius: 12px !important; border: 1px solid #e2e8f0 !important; }
.modern-data-table >>> .v-data-table-header { background-color: #f8fbfc !important; }
.modern-data-table >>> th { height: 52px !important; text-transform: uppercase; font-size: 0.7rem !important; vertical-align: middle !important; }
.modern-data-table >>> td { height: 64px !important; border-bottom: 1px solid rgba(0,0,0,0.03) !important; }

.modern-dialog-shadow { box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important; }
</style>
